import React, { useEffect } from 'react'
import styled from 'styled-components'
import styles from "./classic.scss"

export default function ClassicBanner(props) {
  const Title = styled.strong`
      color: ${ props?.theme?.secondaryColor || props?.style?.title?.color};
      padding: 0px 1.5%;
    `
  const Text = styled.span`
      color: ${ props?.theme?.secondaryColor || props?.style?.text?.color};
      padding: 0px 1.5%;
    `

  useEffect(() => {

    console.log("test", props)

  }, [])



  return (
    <div className='classicBanner w-full' style={{backgroundColor: props?.theme?.primaryColor || props?.style?.title?.background, color: props?.theme?.secondaryColor || props?.style?.title?.color}}>
    
        <div className="container">

          <div className="headline">
           <Title>{props.title ?? "Breaking News:"}</Title> <Text>{props.text ?? "Your text goes here"}</Text>
          </div>
        </div>
    </div>
  )
}
